module.exports = __webpack_public_path__ + "img/logo-login.74062d58.png";